export default __webpack_public_path__ + "media/images/placeholders/christmas-hero-5d4b30b4e16b805d28dc43607b931f51.jpg";